import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar, Box } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../../atoms/Input";
import removeImg from "../../../../imgs/remove.png";
import { useParams } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useLocation } from "react-router-dom";

const ItemConditionDownload = ({ formContent, surveyData }) => {
  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="premium-print-container mx-4">
      <div className="section-divider mb-3">
        <h1 className="section-title">Item Condition Report (Origin)</h1>
      </div>

      {/* detail*/}
      <div className="data-grid mb-4">
        <div className="data-item">
          <span className="data-label">Form ID</span>
          <span className="data-value">{formId || "-"}</span>
        </div>
      </div>

      <div className="mb-4">
        <table className="w-100" style={{ borderCollapse: 'collapse', fontSize: '9pt' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th className="border p-2 text-start" style={{ width: '8%', fontWeight: 700, color: '#64748b' }}>NO.</th>
              <th className="border p-2 text-start" style={{ width: '42%', fontWeight: 700, color: '#64748b' }}>ITEM DESCRIPTION</th>
              <th className="border p-2 text-start" style={{ width: '25%', fontWeight: 700, color: '#64748b' }}>CONDITION</th>
              <th className="border p-2 text-start" style={{ width: '25%', fontWeight: 700, color: '#64748b' }}>DISCLAIMER</th>
            </tr>
          </thead>
          <tbody>
            {formContent?.dataRows?.length > 0 ? (
              formContent?.dataRows.map((row, index) => (
                <tr key={index}>
                  <td className="border p-2 text-center" style={{ verticalAlign: 'top' }}>{index + 1}</td>
                  <td className="border p-2" style={{ verticalAlign: 'top' }}>{row?.description || "-"}</td>
                  <td className="border p-2" style={{ verticalAlign: 'top' }}>{row?.condition || "-"}</td>
                  <td className="border p-2" style={{ verticalAlign: 'top' }}>{row?.disclaimer || "-"}</td>
                </tr>
              ))
            ) : (
               <tr>
                 <td colSpan={4} className="border p-4 text-center text-muted">No items recorded.</td>
               </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Signatures */}
      <div className="mt-5 pt-4">
        <Row>
          <Col sm={6} className="text-center">
            <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
              {formContent?.clientSign && (
                <img src={`${Bucket}${formContent.clientSign}`} height={70} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Client Signature</p>
          </Col>
          <Col sm={6} className="text-center">
            <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
               {formContent?.supervisorSign && (
                <img src={`${Bucket}${formContent.supervisorSign}`} height={70} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Supervisor Signature</p>
          </Col>
        </Row>
      </div>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") ? "success" : "error"} onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};
export default ItemConditionDownload;
